/**
 * Featured Card Web Component
 * Handles YouTube video modal functionality for featured cards
 */
class FeaturedCard extends HTMLElement {
  constructor() {
    super();
    this.youtubeButton = null;
    this.youtubeModal = null;
    this.youtubePlayer = null;
    this.iframe = null;
    this.boundHandleKeydown = this.handleKeydown.bind(this);
  }

  connectedCallback() {
    this.youtubeButton = this.querySelector('.youtube-button');
    this.youtubeModal = this.querySelector('.youtube-modal');
    this.youtubePlayer = this.querySelector('.youtube-player');

    if (this.youtubeButton && this.youtubeModal && this.youtubePlayer) {
      this.youtubeButton.addEventListener('click', this.handleButtonClick.bind(this));
      this.youtubeModal.addEventListener('click', this.handleModalClick.bind(this));
    }
  }

  disconnectedCallback() {
    document.removeEventListener('keydown', this.boundHandleKeydown);
    this.destroyIframe();
  }

  handleButtonClick(event) {
    event.preventDefault();
    event.stopPropagation();
    this.openModal();
  }

  handleModalClick(event) {
    const videoContainer = this.querySelector('.video-container');
    if (videoContainer && !videoContainer.contains(event.target)) {
      this.closeModal();
    }
  }

  handleKeydown(event) {
    if (event.key === 'Escape') {
      this.closeModal();
    }
  }

  openModal() {
    if (!this.youtubeModal || !this.youtubePlayer) return;

    this.injectYouTubePlayer();
    this.youtubeModal.classList.remove('hidden');
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', this.boundHandleKeydown);

    // Focus trap - focus the modal for accessibility
    this.youtubeModal.setAttribute('tabindex', '-1');
    this.youtubeModal.focus();
  }

  closeModal() {
    if (!this.youtubeModal) return;

    this.youtubeModal.classList.add('hidden');
    document.body.style.overflow = '';
    document.removeEventListener('keydown', this.boundHandleKeydown);
    this.destroyIframe();

    // Return focus to the button
    if (this.youtubeButton) {
      this.youtubeButton.focus();
    }
  }

  injectYouTubePlayer() {
    if (!this.youtubePlayer || this.iframe) return;

    const youtubeUrl = this.youtubePlayer.dataset.youtubeUrl;
    if (!youtubeUrl) return;

    this.iframe = document.createElement('iframe');
    this.iframe.className = 'absolute inset-0 w-full h-full border-0 z-50';
    this.iframe.setAttribute('src', youtubeUrl);
    this.iframe.setAttribute('title', 'YouTube video player');
    this.iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
    this.iframe.setAttribute('allowfullscreen', '');
    this.iframe.setAttribute('loading', 'lazy');

    this.youtubePlayer.appendChild(this.iframe);
  }

  destroyIframe() {
    if (this.iframe) {
      this.iframe.remove();
      this.iframe = null;
    }
  }
}

if (!customElements.get('featured-card')) {
  customElements.define('featured-card', FeaturedCard);
}
